// extracted by mini-css-extract-plugin
export var section = "_1a-1";
export var topNav = "_1a-0";